import {
	ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS,
	ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT,
	ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS,
} from '@atlassian/jira-common-constants/src/spa-routes';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { ff } from '@atlassian/jira-feature-flagging';
import type { JiraSoftwareNavData } from '@atlassian/jira-navigation-apps-resources';
import type { Features } from './types';

export const extractData = (data: JiraSoftwareNavData): Features => {
	const {
		aiInfo,
		hasBacklog,
		hasBoard,
		hasCalendar,
		hasCode,
		hasDeployments,
		hasGoals,
		hasIncidents,
		hasIssues,
		hasList,
		hasOpsgenieSchedule,
		hasPages,
		hasReleases,
		hasReports,
		hasRequests,
		hasRoadmap,
		hasSecurity,
		permissionInfo,
	} = data;
	const isProjectOrSiteAdmin =
		permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
	const hasEditWorkflowPermissions =
		permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
	const hasEditIssueLayoutPermissions =
		permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;

	const settingsPanelRoute = (() => {
		const defaultSettingsPanelRoute = ff(
			'hix-4818-adopt-modern-project-details-page-across-all-products_3zvy1',
		)
			? {
					href: (projectKey: string) => `/jira/software/c/projects/${projectKey}/settings`,
					selectedOn: [ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS],
				}
			: {
					href: (projectKey: string) => `/plugins/servlet/project-config/${projectKey}`,
					selectedOn: [ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT],
				};

		if (ff('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
			if (!isProjectOrSiteAdmin) {
				if (hasEditWorkflowPermissions) {
					return {
						href: (projectKey: string) => `/plugins/servlet/project-config/${projectKey}/workflows`,
						selectedOn: [ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS],
					};
				}
				if (hasEditIssueLayoutPermissions) {
					return {
						href: (projectKey: string) =>
							`/plugins/servlet/project-config/${projectKey}/issuelayout`,
						selectedOn: [ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS],
					};
				}
			}
		}
		return defaultSettingsPanelRoute;
	})();

	return {
		hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
		hasBacklog,
		hasBoard,
		hasCalendar,
		hasCode,
		hasComponents: true,
		hasDeployments,
		hasGoals,
		hasIncidents,
		hasIssues,
		hasList: expValEquals('jsw_list_view', 'cohort', 'variation') ? hasList : false,
		hasOpsgenieSchedule,
		hasPages,
		hasReleases,
		hasReports,
		hasRequests,
		hasRoadmap,
		hasSecurity,
		hasSettings: ff('olympus-da-157-enable-project-settings-navigation_zxaq5')
			? isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions
			: isProjectOrSiteAdmin,
		hasShortcutsAdd: isProjectOrSiteAdmin,
		settingsPanelRoute,
	};
};
